import {
  CROSS_CLIENT_PREDEFINED_CATEGORIES,
  CROSS_CLIENT_PREDEFINED_ICONS,
  PredefinedCrossClientQuery,
  CrossClientPredefinedCategory,
} from '../../Predefined/crossClientPredefinedQueries'
import classNames from 'classnames'
import React, { useState } from 'react'
import { useAppSelector } from '../../../../store/hooks'
import { selectCrossClientLandingFinishedExecutions, selectCrossClientLandingRunningExecutions } from '../../../../store/crossClient/crossClientLanding'
import { CrossClientLandingPredefinedQueries } from '../Predefined/CrossClientLandingPredefinedQueries'
import { CrossClientLandingHistory } from '../History/CrossClientLandingHistory'
import { CrossClientQueryExecution } from '../../../../models/CrossClient'

type CrossClientPillOption = 'History' | CrossClientPredefinedCategory

export interface CrossClientLandingFooterProps {
  rerunDisabled: boolean
  onPredefinedQuerySelect: (crossClientDefault: PredefinedCrossClientQuery) => void
  onRerun: (execution: CrossClientQueryExecution) => void
}

export const CrossClientLandingFooter: React.FC<CrossClientLandingFooterProps> = ({ rerunDisabled, onPredefinedQuerySelect, onRerun }) => {
  const runningExecutions = useAppSelector(selectCrossClientLandingRunningExecutions)
  const finishedExecutions = useAppSelector(selectCrossClientLandingFinishedExecutions)

  const hasExecution = runningExecutions.length || finishedExecutions.length

  const [selectedPill, setSelectedPill] = useState<CrossClientPillOption>(finishedExecutions.length ? 'History' : 'Featured')

  return (
    <div className='d-flex flex-column zocks-gap-2 w-100 zocks-mb-4'>
      <div className='d-flex gap-2 justify-content-center'>
        {hasExecution ? (
          <CrossClientPill title='History' selected={selectedPill === 'History'} onClick={() => setSelectedPill('History')} icon={'bi-clock-history'} />
        ) : null}
        {CROSS_CLIENT_PREDEFINED_CATEGORIES.map((key: CrossClientPredefinedCategory) => {
          const selected = selectedPill === key
          return <CrossClientPill key={key} title={key} selected={selected} icon={CROSS_CLIENT_PREDEFINED_ICONS[key]} onClick={() => setSelectedPill(key)} />
        })}
      </div>
      {selectedPill === 'History' ? (
        <CrossClientLandingHistory onRerun={onRerun} rerunDisabled={rerunDisabled} />
      ) : (
        <CrossClientLandingPredefinedQueries selectedCategory={selectedPill} onSelect={onPredefinedQuerySelect} />
      )}
    </div>
  )
}

interface CrossClientPillProps {
  title: string
  selected: boolean
  icon?: string
  onClick: () => void
}

const CrossClientPill: React.FC<CrossClientPillProps> = ({ title, selected, icon, onClick }) => {
  const [hovered, setHovered] = useState<boolean>(false)

  return (
    <div
      className={classNames('d-flex gap-2 px-2 py-1 align-items-center zocks-border-0.5 border border-1 bg-white cross-client-transition', {
        'zocks-text-primary zocks-bg-color-primary-light': selected,
        'zocks-border-color-gray-500': !selected && !hovered,
        'zocks-border-color-primary': selected || hovered,
      })}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      role='button'
    >
      {icon ? <i className={`bi ${icon}`} /> : null}

      <div className='paragraph-small medium'>{title}</div>
    </div>
  )
}
